import {
  RedeemableStoreCouponHistoryType,
  userSearchParams,
} from '../../types/resources/RedeemableStoreCouponHistoryType';
import { fetchWrapper } from '../fetchWrapper';

type GetResponseType = {
  data: {
    redeemable_store_coupons: RedeemableStoreCouponHistoryType[];
  };
  headers: Record<string, string>;
};

export const getRedeemableStoreCouponHistories = async (
  signOut: () => void,
  searchParams: userSearchParams
): Promise<GetResponseType> => {
  const queryString = new URLSearchParams(searchParams).toString();
  const response = await fetchWrapper(
    '/redeemable_store_coupons',
    {
      method: 'GET',
      queryString,
    },
    signOut
  );

  if (!response.ok) {
    throw new Error(`${response.status} ${response.statusText}`);
  }

  const data = await response.json();
  return {
    data,
    headers: Object.fromEntries(response.headers.entries()),
  };
};
